import { DataGridPro, GridToolbarExport, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton } from '@mui/x-data-grid-pro';
// import { Chip } from '@mui/material';
import moment from 'moment';
import React from 'react';
import * as CustomerApi from '../../Services/CustomerApi'

export default function CustomerSubscriptions() {
    
    const [historyList, setHistoryList] = React.useState([])


    const columns = [
        { 
            field: 'id', 
            headerName: 'User Id', 
            width: 100, 
            editable: false ,
            renderCell: (params) => {
                return (<a href={'/customer/' + params.id} target='_blank' rel='noreferrer' style={{textDecoration: 'underline'}}>{params.value}</a>);
              },
        },        
        {
            field: 'user_name',
            headerName: 'Name',
            width: 150, 
            editable: false,
            renderCell: (params) => {
                return (<a href={'/customer/' + params.id} target='_blank' rel='noreferrer' style={{textDecoration: 'underline'}}>{params.value}</a>);
              },
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 200, 
            editable: false,
        },
        {
            field: 'dialCode',
            headerName: 'Country Code',
            width: 150,
            editable: false, 
        },
        {
            field: 'phone',
            headerName: 'Phone',
            width: 150, 
            editable: false,
        },
        {
            field: 'date_of_birth',
            headerName: 'DOB',
            type: 'date',
            width: 150, 
            valueFormatter: (params) => {
                return params.value ? moment(params.value).format('MMM DD, YYYY') : "";
            },
            valueGetter: (params) => {
                return params.value ? moment(params.value) : "";
            },
            editable: false,
        },
        {
            field: 'city_name',
            headerName: 'City',
            width: 150, 
            editable: false,
        },
        {
            field: 'country_name',
            headerName: 'Country',
            type: 'singleSelect',
            width: 150, 
            editable: false,
            valueOptions:['Australia', 'Canada', 'United States', 'United Kingdom', 'New Zealand']
        },
        {
            field: 'createdOn',
            headerName: 'Member Since',
            valueFormatter: (params) => {
                return params.value ? moment(params.value).format('MMM DD, YYYY') : "";
            },
            valueGetter: (params) => {
                return params.value ? moment(params.value) : "";
            },
            width: 150, 
            editable: false,
        },
        
    ];

   

    const fetchSubscriptionData = React.useCallback(async () => {
        const data = await CustomerApi.getCustomersWithSubscriptions();
        const mappedList = [];
       
        data.forEach((user) => {
            
            mappedList.push({
                "id" : user.id,
                "user_name" : user.user_name,
                "email": user.email,
                "phone" : user.phone,
                "date_of_birth" : user.date_of_birth,
                "city_name" : user.city_name,
                "country_name" : user.country_name,
                "createdOn" : user.createdOn,
                "dialCode":user.dialCode
            });

        });

        setHistoryList(mappedList);

    }, []);

    React.useEffect(() => {
        fetchSubscriptionData();
    }, [fetchSubscriptionData])        

    return (
        historyList?.length > 0 ?
            <DataGridPro
                style={{ flex: 1 }}
                rows={historyList}
                columns={columns}
                pagination={true}
                pageSize={50}
                sx={{
                    height: '600px',
                    '.MuiDataGrid-columnHeaders': {
                        fontWeight: 'bold',
                        fontSize: 14,
                        color: 'rgb(0,0,0)',
                        backgroundColor: 'rgb(244,246,248)',
                    },
                    '.MuiTablePagination-selectLabel': {
                        marginBottom: '0px',
                    },
                    '.MuiTablePagination-displayedRows': {
                        marginBottom: '0px',
                    },
                    '.MuiPaper-root.div.span': {
                        color: 'blue',
                    },
                }}
                components={{ Toolbar: dataGridToolbar  }}
                componentsProps={{
                    panel: {
                      sx: {
                        '& .MuiTypography-root': {
                            color: '#000',
                        },
                        '& .MuiSwitch-switchBase.Mui-checked': {
                            color: '#D1517A',
                        },
                        '& .MuiSwitch-switchBase.Mui-checked+.MuiSwitch-track': {
                            backgroundColor: '#D1517A',
                        },                          
                        '& .MuiFormLabel-root': {
                            color: '#D1517A',
                        },
                        '& .MuiButton-root': {
                            color: '#D1517A',
                        },
                        '& .MuiInputLabel-root': {
                            color: '#D1517A',
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                            color: '#D1517A',
                        },
                        '& .MuiInput-root:after': {
                            borderBottom: '1px solid #000',
                        },
                      },
                    },
                  }}
            />
            :
            "Loading Customers..."    
       
    );

    function dataGridToolbar() {
        return (
          <GridToolbarContainer style={{paddingTop: '10px'}}>
            <GridToolbarColumnsButton style={{color: '#434F69'}} />
            <GridToolbarFilterButton style={{color: '#434F69'}}/>
            <GridToolbarExport style={{color: '#434F69'}}/>
          </GridToolbarContainer>
        );
      }
}